import { SerializedStyles, css } from '@emotion/react';

/** Quick Header brand logos */
export const iconFillQuickHeader = (): SerializedStyles => css`
    width: 20px;
    flex: 0 0 20px;
    fill: currentcolor;
`;
